import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  ApiResponse,
  EventDownloadResponse,
  EventUIResponse,
} from "../../models/ApiResponse";
import agent from "../../api/agent";
import { EventResponse } from "../../models/responseModels/eventResponse";
import {
  AddEventRequest,
  UpdateEventRequest,
} from "../../models/requestModels/eventRequest";

type InitialState = {
  isLoading: boolean;
  eventList: EventResponse[];
  errorMessage: string | null;
};

const initialState: InitialState = {
  isLoading: false,
  eventList: [],
  errorMessage: null,
};

export const getEventList = createAsyncThunk<EventUIResponse>(
  "event/eventResponse",
  async () => {
    const response = await agent.EventAgent.getEventList();
    return response;
  }
);

export const downloadEventDataToCsv = createAsyncThunk<
  EventDownloadResponse,
  EventResponse[]
>("event/downloadCsv", async (eventsData: EventResponse[]) => {
  const response = await agent.EventAgent.eventCsvDownload(eventsData);
  return response;
});

export const downloadEventDataToXlsx = createAsyncThunk<Blob, EventResponse[]>(
  "event/downloadXlsx",
  async (eventsData: EventResponse[]) => {
    const response = await agent.EventAgent.eventXlsxDownload(eventsData);
    return response;
  }
);

export const updateEvent = createAsyncThunk<ApiResponse, UpdateEventRequest>(
  "event/updateEvent",
  async (updateEventRequest: UpdateEventRequest) => {
    const response = await agent.EventAgent.updateEvent(updateEventRequest);
    return response;
  }
);

export const addEvent = createAsyncThunk<ApiResponse, AddEventRequest>(
  "event/addEvent",
  async (addEventRequest: AddEventRequest) => {
    const response = await agent.EventAgent.addEvent(addEventRequest);
    return response;
  }
);

const eventSlice = createSlice({
  name: "event",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getEventList.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getEventList.fulfilled, (state, action) => {
        state.isLoading = false;
        if (action.payload.isSuccess) {
          state.eventList = action.payload.data;
        } else {
          state.eventList = [];
        }
      })
      .addCase(getEventList.rejected, (state, action) => {
        state.isLoading = false;
        state.eventList = [];
        state.errorMessage = action.error.message!;
      });
  },
});

export default eventSlice.reducer;
